import styled from 'styled-components';

interface EmptyDataProps {
  fromMultiCard?: boolean;
}

const EmptyData = styled.div<EmptyDataProps>`
  font-family: ui-sans-serif,system-ui,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,Noto Color Emoji;
  color: #475569;
  pointer-events: none;
  position: ${({ fromMultiCard }) => (fromMultiCard ? 'static' : 'absolute')};
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  font-size: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999999;
  overflow: overlay;
`;

export default EmptyData;
